import React from 'react';
import SubHeader from '../../components/Layout/SubHeader';
import { getAuthToken, storeUserData } from '../../components/Util';
import api from '../../config/api';
import axios from 'axios';
import { withRouter } from '../../config/withRouter';
import { images } from '../../config/image';
import { Rate } from 'antd';
import strings from '../../components/Language';
import { ProgressBar } from 'react-loader-spinner';

class InstallerDetailsScreen extends React.Component {
    constructor(props) {
        super(props);
        const { id } = this.props.params; // Access the ID from URL parameters        
        this.state = {
            ProgressBar: true,
            lang: strings.getLanguage(),
            access_token: null,
            data: {},
            showAlert: false,
            alertMessage: '',
            alertTitle: '',
            isLoading: false,
            id: id,
            gender: '1',
            gender_data: {},
            company: '',
            mobile: '',
            race: '',
            exp_year: '',
            worker_count: '',
            o_tag: '',
            address: '',
            city: null,
            newSkill: [],
            commentData: [],
            skill_array: [strings["specialty1"], strings["specialty2"], strings["specialty3"], strings["specialty4"]],
            PreviousPageLink: '',
            NextPageLink: '',
            owner: [],
        }
    }

    async componentDidMount() {
        let self = this;
        var token = await getAuthToken();

        if (token) {
            self.setState({ access_token: token });
            await storeUserData(token, this);
            setTimeout(() => {
                self.getInstaller();
                self.getCommentList(api.InstallerCommentList + self.state.id);
            });
        }
    }

    getInstaller() {
        const self = this;
        self.setState({ 'isLoading': true })
        axios({
            method: 'GET',
            url: api.InstallerSingle + self.state.id,
            headers: {
                'Authorization': 'Bearer ' + self.state.access_token,
                'Content-Type': 'application/json'
            }
        }).then(function (ress) {
            self.setState({
                isLoading: false,
                data: ress.data.message,
                owner: ress.data.message.owner,
                company: ress.data.message.company,
                exp_year: ress.data.message.exp_year.toString(),
                gender: ress.data.message.gender,
                gender_data: ress.data.message.gender_data,
                s_tag: ress.data.message.s_tag,
                address: ress.data.message.address,
                mobile: ress.data.message.mobile,
                race: ress.data.message.race,
                worker_count: ress.data.message.worker_count.toString(),
                overall_rating: ress.data.message.overall_rating,
                city: ress.data.message.city,
                ProgressBar: false
            });
        }).catch(function (erro) {
            self.setState({
                ProgressBar: false,
                isLoading: false
            });
        });
    }

    getCommentList(APIURL) {
        const self = this;
        self.setState({ 'isLoading': true })
        axios({
            method: 'GET',
            url: APIURL + "?lang=" + self.state.lang,
            headers: {
                'Authorization': 'Bearer ' + self.state.access_token,
                'Content-Type': 'application/json',
            }
        }).then(function (ress) {
            self.setState({ 'isLoading': false })
            self.setState({
                commentData: ress.data.message.data,
                NextPageLink: ress.data.message && ress.data.message.next_page_url ? ress.data.message.next_page_url : '',
                PreviousPageLink: ress.data.message && ress.data.message.prev_page_url ? ress.data.message.prev_page_url : ''
            })
        }).catch(function (erro) {
            self.setState({ 'isLoading': false });

        });

    }

    render() {

        return (
            <>
                <ProgressBar visible={this.state.ProgressBar} height="80" width="80" color="#f05a29" borderColor='#f05a29' barColor='#f05a29' wrapperClass="progress-bar" />
                <SubHeader data={{ title: strings["installerTitle"] }} />

                <div className='installer-screen'>
                    <main>
                        <div className="installer-section">
                            <h1 id="installerTitle" className="installer-title">{strings["installerTitle"]}</h1>
                        </div>

                        <div className="align-form">
                            <div className="form-container" style={{ paddingBottom: 25 }}>
                                <div className="info-wrap">
                                    {this.state.owner.pic_url ?
                                        <img className="installer-image" src={this.state.owner.pic_url} alt='' />
                                        :
                                        <img className="installer-image" src={images['profile-icon']} alt='' />
                                    }
                                    {/* <div className="align-right">
                                        <p>{this.state.company ?? ''}</p>
                                        <p>{this.state.mobile ?? ''}</p>
                                        <p className="ratings">{strings["Overall Rating"]} ({this.state.overall_rating ? <Rate disabled defaultValue={this.state.overall_rating} /> : strings["(no rating)"]})</p>
                                    </div> */}
                                </div>

                                <div className="form-content">
                                    <label id="companyLabel">{strings["companyLabel"]}<span>*</span></label>
                                    <p>{this.state.company ?? ''}</p>
                                </div>
                                <div className="form-content">
                                    <label id="contactLabel">{strings["contactLabel"]}<span>*</span></label>
                                    <p>{this.state.mobile ?? ''}</p>
                                </div>
                                <div className="form-content">
                                    <label id="genderLabel">{strings["genderLabel"]}<span>*</span></label>
                                    <p>
                                        {(this.state.gender_data && this.state.gender_data.name) ? this.state.gender_data.name : '-'}
                                    </p>
                                </div>
                                <div className="form-content">
                                    <label id="raceLabel">{strings["raceLabel"]}<span>*</span></label>
                                    <p>{this.state.race ?? ''}</p>
                                </div>
                                <div className="form-content">
                                    <label id="experienceLabel">{strings["experienceLabel"]}</label>
                                    <p>{this.state.exp_year ?? ''}</p>
                                </div>
                                <div className="form-content">
                                    <label id="workerLabel">{strings["workerLabel"]}</label>
                                    <p>{this.state.worker_count ?? ''}</p>
                                </div>
                                <div className="specialty-content">
                                    <label id="specialtyLabel">{strings["specialtyLabel"]}</label>
                                    <p>{this.state.s_tag}</p>
                                </div>
                                <div className="address-content">
                                    <label id="addressLabel">{strings["addressLabel"]}</label>
                                    <p id="addressDetail" className="address-detail">
                                        {this.state.address}
                                    </p>
                                </div>
                                <div className="form-content">
                                    <label id="CityLabel">{strings["City"]}<span>*</span></label>
                                    <p>{(this.state.city && this.state.city.name) ? this.state.city.name : '-'}</p>
                                </div>
                            </div>
                        </div>

                        <div className="installer-section">
                            <h1 id="commentLabel" className="installer-title">{strings["commentLabel"]}</h1>
                        </div>
                        <div className='align-form'>
                            <div className="form-container comment-section">
                                {this.state.commentData.map((item, i) =>
                                    <div className="info-wrap">
                                        <div>
                                            {item.comment_by.pic_url ?
                                                <img className="installer-image" src={item.comment_by.pic_url + "?ver=" + Math.random()} style={{ width: 50, height: 50 }} alt='' />
                                                :
                                                <img className="installer-image" src={images['profile-icon']} style={{ width: 50, height: 50 }} alt='' />
                                            }
                                        </div>
                                        <div className="align-right">
                                            <p>{item.comment_by.username}</p>
                                            <p><Rate disabled defaultValue={(item.rating > 0) ? item.rating : 0} /></p>
                                            <p>{item.body}</p>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </main>
                </div>
            </>
        );
    }
}

export default withRouter(InstallerDetailsScreen);
